export default "__VITE_ASSET__g7GF79fdYiVx4JT7dzonJA__"